var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.getTooltipClass(),attrs:{"href":"javascript:void(0)","tooltip":_vm.getTooltip(),"flow":"down"},on:{"click":function($event){return _vm.openUrl()}}},[_c('img',{attrs:{"src":_vm.image}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330a1edc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/HkepThumbnail.vue
// module id = 57GV
// module chunks = 2 3 4 5 6